var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2631.799,
    height: 3795.5,
    viewBox: "0 0 2631.799 3795.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(446 -1379)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 383.5,
    cy: 383.5,
    r: 383.5,
    transform: "translate(-446 1379)",
    fill: "#9f9f9f",
    opacity: 0.239
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M302.5,0C469.566,0,605,135.434,605,302.5S469.566,605,302.5,605,0,469.566,0,302.5,135.434,0,302.5,0Z",
    transform: "matrix(0.208, -0.978, 0.978, 0.208, 1468.233, 2490.932)",
    fill: "#9f9f9f",
    opacity: 0.239
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 302.5,
    cy: 302.5,
    r: 302.5,
    transform: "matrix(0.208, -0.978, 0.978, 0.208, -242.566, 5048.713)",
    fill: "#9f9f9f",
    opacity: 0.239
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 302.5,
    cy: 302.5,
    r: 302.5,
    transform: "matrix(0.208, -0.978, 0.978, 0.208, 1424.5, 4188.779)",
    fill: "#c44343",
    opacity: 0.239
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    transform: "matrix(0.208, -0.978, 0.978, 0.208, 1205.201, 2574.061)",
    fill: "none",
    stroke: "#c44343",
    strokeWidth: 10,
    opacity: 0.239
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 302.5,
    cy: 302.5,
    r: 302.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.5,
    cy: 302.5,
    r: 297.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    transform: "matrix(0.208, -0.978, 0.978, 0.208, 1550.365, 4823.341)",
    fill: "none",
    stroke: "#c44343",
    strokeWidth: 10,
    opacity: 0.239
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 196.379,
    cy: 196.379,
    r: 196.379,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.379,
    cy: 196.379,
    r: 191.379,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.a40ce29a640020a73cb6c45cba1a72d6.svg";
export { ForwardRef as ReactComponent };